<template>
	<Card :bordered="false" :key="task.id">
		<div class="flex-wrapper">
			<div class="flex-grow">
				{{ task.trimmed_directory }}
			</div>
			<div>
				<DateTimeDisplay :date="task.created" />
			</div>
		</div>
		<div v-if="isLoading">
			<LoadingOutlined />
			<span class="loading-text">{{ $t('settings.ftp-navigator.messages.downloadingArchive', task.selected_files_count) }}</span>
		</div>
		<div v-else :class="task.status === 'done' ? 'mouse-pointer' : ''" @click="getFileInDirectoryCheckStatus(task)">
			<StatusDisplay
				class="file-badge"
				:source="task"
				field="status"
				prefix="settings.ftp-navigator.taskStatus"
				:badgeDict="TASK_STATUS_BADGES"
			/>
			{{ $t('settings.ftp-navigator.messages.filesCount', task.selected_files_count) }}
		</div>
	</Card>
</template>

<script>
import { ref } from 'vue';

import { Card, message } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';

import { useI18n } from 'vue-i18n';

import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import StatusDisplay from '@/components/common/StatusDisplay.vue';

import Api from '@/api/Api';

const TASK_STATUS_BADGES = {
	created: 'processing',
	done: 'success',
	failed: 'error',
};

export default {
	components: {
		Card, DateTimeDisplay, LoadingOutlined, StatusDisplay,
	},
	props: ['task'],
	setup() {
		const { t } = useI18n();
		const isLoading = ref(false);
		const errorHandler = error => {
			if (error?.response?.status === 403) {
				message.error(t('settings.ftp-navigator.messages.noValidFiles'));
			} else {
				message.error(t('settings.ftp-navigator.messages.downloadError'));
			}
		}
		const successHandler = () => {
			isLoading.value = false;
		}
		const getFileInDirectoryCheckStatus = task => {
			if (task.status === 'done' && !isLoading.value) {
				isLoading.value = true;
				const lastSlashIndex = task.result_filename.lastIndexOf('/');
				const filename = lastSlashIndex !== -1 ? task.result_filename.substring(lastSlashIndex + 1) : task.result_filename;
				Api.ftpGetFile(filename, task.result_filename, successHandler, errorHandler);
			}
		}
		return {
			TASK_STATUS_BADGES,
			isLoading,
			getFileInDirectoryCheckStatus,
		};
	},
}
</script>

<style scoped>
.loading-text {
	margin-inline-start: 8px;
}
.file-badge {
	margin-inline-start: 7px;
}
</style>
